<template>
  <div id="app">
    <Header />

    <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
      <router-view/>
    </transition>

    <Footer />
  </div>
</template>

<style lang="stylus">
@import 'css/main'

.fade-enter-active,
.fade-leave-active
  transition-duration 0.3s
  transition-property height, opacity
  transition-timing-function ease
  overflow hidden

.fade-enter,
.fade-leave-active
  opacity: 0
</style>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import axios from 'axios';

export default {
  data() {
    return {
      prevHeight: 0,
    };
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
  },
  async mounted () {
    if (process.env.NODE_ENV === 'production') {
			this.$store.state.translations = window.translations;
    } else {
			axios.get(`${process.env.VUE_APP_WORDPRESS_URL}/wp/wp-json/wp/v2/pages?lang=${this.$route.params.lang || ''}`).then(response => {
				this.$store.state.translations = response.data[0].acf;
			});
    }

		axios.get(`${process.env.VUE_APP_WORDPRESS_URL}/wp/wp-json/wp/v2/posts?lang=${this.$route.params.lang || ''}`).then(response => {
			this.$store.state.articles = response.data;
		});
	},
  components: {
    Header,
    Footer,
  }
}
</script>